import React, {useContext} from 'react';
import {Typography, SvgIcon} from '@material-ui/core';
import {Grid, Checkbox} from '@mantine/core';
import {useFormikContext} from "formik";
import {makeStyles} from "@material-ui/core/styles";
import PopOverDetails from "../../../../../PopOverInfo";
import HikingIcon from '@mui/icons-material/Hiking';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import CallIcon from '@mui/icons-material/Call';
import AffinityContext from "../../../../../../context/AffinityContext";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";
import {IconBike, IconCamera, IconDeviceLaptop, IconDeviceTablet, IconScooter} from "@tabler/icons";

const useStyles = makeStyles(() => ({
    coverageIcon: {
        width: "32px",
        height: "32px",
        strokeWidth: "2px",
    },
    noCost: {
        fontFamily: 'EncodeSansBold',
        fontSize: "14px",
        textAlign: "center"
    },
    tableHeader: {
        fontFamily: 'EncodeSansBold',
        fontSize: "18px",
        lineHeight: "1"
    },
    tableRowLabel: {
        fontFamily: 'Nunito'
    },
    centerContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    tableHeaderContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingRight: "64px",
    },
}));

export default function CoberturasForm() {
    const {coberturasInfo} = useContext(AffinityContext);
    const classes = useStyles();
    const {values, setFieldValue} = useFormikContext();
    const coberturasAdicionalesIcons = {
        26: <IconCamera className={classes.coverageIcon}/>,
        36: <IconDeviceLaptop className={classes.coverageIcon}/>,
        37: <IconDeviceTablet className={classes.coverageIcon}/>,
        48: <IconBike className={classes.coverageIcon}/>,
        49: <IconScooter className={classes.coverageIcon}/>,
    }
    const noCostCoverages = [
        {selected: true, numeroCobertura: "44", sumaAsegurada: "Sin Costo", icon: HikingIcon},
        {selected: true, numeroCobertura: "45", sumaAsegurada: "Sin Costo", icon: MedicalServicesIcon},
        {selected: true, numeroCobertura: "50", sumaAsegurada: "Sin Costo", icon: CallIcon},
    ];

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={12}>
                    <div className={classes.tableHeaderContainer}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>
                </Grid.Col>

                {Object.keys(values.coberturas).map(cobertura => {
                    return (
                        <>
                            <Grid.Col xs={1} sm={1}>
                                <Checkbox
                                    checked={values.coberturas[cobertura].selectedCobertura}
                                    classNames={{
                                        input: "checkbox",
                                        root: "checkbox",
                                        body: "checkbox",
                                    }}
                                    size="sm"
                                    onChange={(e) => {
                                        const {checked} = e.target;
                                        setFieldValue(`coberturas.[${cobertura}].selectedCobertura`, checked);
                                    }}
                                />
                            </Grid.Col>
                            <Grid.Col xs={1} sm={1}>
                                {coberturasAdicionalesIcons[cobertura]}
                            </Grid.Col>
                            <Grid.Col xs={5} sm={5}>
                                <Typography className={classes.tableRowLabel}>
                                    {coberturasInfo[cobertura].descripcion}
                                </Typography>
                            </Grid.Col>
                            <Grid.Col xs={4} sm={4} style={{
                                visibility: values.coberturas[cobertura] && values.coberturas[cobertura].selectedCobertura ? "visible" : "hidden"
                            }}>

                                <MantineNumberField
                                    name={`coberturas.${cobertura}.sumaAsegurada`}
                                    min={coberturasInfo[cobertura]['sumaMinima']}
                                    max={coberturasInfo[cobertura]['sumaMaxima']}
                                    styles={{input: {textAlign: "right"}}}
                                />
                            </Grid.Col>
                            <Grid.Col xs={1} sm={1}>
                                <PopOverDetails
                                    descripcion={coberturasInfo[cobertura].descripcionCompleta}
                                />
                            </Grid.Col>
                        </>
                    )
                })}

                {noCostCoverages.map((item) => (
                    <>
                        <Grid.Col xs={1} sm={1}>
                            <Checkbox
                                checked={true}
                                classNames={{
                                    input: "checkbox",
                                    root: "checkbox",
                                    body: "checkbox",
                                }}
                                size="sm"
                            />
                        </Grid.Col>
                        <Grid.Col xs={1} sm={1}>
                            <SvgIcon component={item.icon}
                                     fontSize="large"
                                     style={{
                                         width: "32px",
                                         height: "32px",
                                     }}
                            />
                        </Grid.Col>
                        <Grid.Col xs={5} sm={5}>
                            <Typography className={classes.tableRowLabel}>
                                {coberturasInfo[item.numeroCobertura].descripcion}
                            </Typography>
                        </Grid.Col>
                        <Grid.Col xs={4} sm={4}>

                            <p className={classes.noCost}>Sin costo</p>
                        </Grid.Col>
                        <Grid.Col xs={1} sm={1}>
                            <PopOverDetails
                                descripcion={coberturasInfo[item.numeroCobertura].descripcionCompleta}
                            />
                        </Grid.Col>
                    </>
                ))}
            </Grid>
        </React.Fragment>
    );
}

